import React, {ReactElement} from 'react';

import {Device, useDevice} from '@fo/shared-providers/DeviceContext';
import {INavigationSection} from '../types';
import NavigationSectionMobile from './NavigationSectionMobile/NavigationSectionMobile';
import NavigationSectionDesktop from './NavigationSectionDesktop/NavigationSectionDesktop';

function NavigationSection({card, col1, col2, col3}: INavigationSection): ReactElement {
  const {device} = useDevice();

  return device === Device.DESKTOP ? (
    <NavigationSectionDesktop card={card} col1={col1} col2={col2} col3={col3} />
  ) : (
    <NavigationSectionMobile card={card} col1={col1} col2={col2} col3={col3} />
  );
}

export default NavigationSection;
